/* =========================================================
   tm-modal.js
   - Newsletter modal open/close (data-tm-newsletter-open / data-tm-modal-close)
   - Toast + voucher + copy button + pause-on-hover
   - Newsletter success toast after reload (.tm-nl__status--ok)
   - Auto-open newsletter on homepage + product pages:
     Trigger = 25 s ODER 45 % Scrolltiefe ODER Exit Intent (Desktop).
     Max. 1x pro Session; nach Wegklicken 7 Tage Pause;
     nach erfolgreicher Anmeldung dauerhaft aus.
     Manuelles Oeffnen ueber data-tm-newsletter-open geht immer.
   ========================================================= */
/* ===== Modal open/close ===== */
document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-tm-newsletter-open]');
  const close = e.target.closest('[data-tm-modal-close]');
  const modal = document.getElementById('tm-newsletter');
  if (!modal) return;
  if (open) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    return;
  }
  if (close) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    /* Nach Wegklicken: Auto-Popup 7 Tage pausieren */
    try { localStorage.setItem('tm_nl_dismissed_at', String(Date.now())); } catch (err) {}
  }
});
/* ===== Toast helpers ===== */
function TMToast(msg, opts = {}) {
  const toast = document.getElementById('tm-toast');
  const text = document.getElementById('tm-toast-msg');
  if (!toast || !text) return;
  const {
    duration = 12000,
    voucher = '',     // e.g. "TALMEA10"
    autoCopy = false  // true => try copy immediately
  } = opts;
  // Build content
  if (voucher) {
    text.innerHTML = `
      <span class="tm-toast__text">${String(msg)}</span>
      <span class="tm-toast__voucher">
        <span class="tm-toast__code">${voucher}</span>
        <button type="button" class="tm-toast__copy" data-tm-toast-copy>
          Kopieren
        </button>
      </span>
    `;
  } else {
    text.textContent = msg;
  }
  toast.hidden = false;
  toast.classList.add('is-visible');
  const startTimer = () => {
    window.clearTimeout(window.__tmToastTimer);
    window.__tmToastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => { toast.hidden = true; }, 250);
    }, duration);
  };
  const stopTimer = () => window.clearTimeout(window.__tmToastTimer);
  // pause on hover (bind once)
  if (!toast.__tmHoverBound) {
    toast.addEventListener('mouseenter', stopTimer, { passive: true });
    toast.addEventListener('mouseleave', startTimer, { passive: true });
    toast.__tmHoverBound = true;
  }
  // copy handler (bind once)
  if (!toast.__tmCopyBound) {
    toast.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-tm-toast-copy]');
      if (!btn) return;
      const codeEl = toast.querySelector('.tm-toast__code');
      const code = codeEl ? codeEl.textContent.trim() : '';
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        btn.textContent = 'Kopiert';
        btn.disabled = true;
        window.setTimeout(() => {
          btn.textContent = 'Kopieren';
          btn.disabled = false;
        }, 1600);
      } catch (err) {
        // fallback: select code for manual copy
        if (codeEl) {
          const range = document.createRange();
          range.selectNodeContents(codeEl);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    });
    toast.__tmCopyBound = true;
  }
  startTimer();
  // optional auto-copy (best effort; some browsers require user gesture)
  if (voucher && autoCopy) {
    window.setTimeout(async () => {
      try { await navigator.clipboard.writeText(voucher); } catch (e) {}
    }, 50);
  }
}
/* Close toast (X) */
document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-tm-toast-close]')) return;
  const toast = document.getElementById('tm-toast');
  if (!toast) return;
  toast.classList.remove('is-visible');
  window.setTimeout(() => { toast.hidden = true; }, 250);
});
/* ===== Newsletter success after reload ===== */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('tm-newsletter');
  if (!modal) return;
/* Voucher Version
  const ok = modal.querySelector('.tm-nl__status--ok');
  if (ok) {
    TMToast('Danke! Du bist jetzt angemeldet. Dein Gutschein:', {
      voucher: 'TALMEA10',
      duration: 12000,
      autoCopy: true
    });
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }
});
*/
const ok = modal.querySelector('.tm-nl__status--ok');
  if (ok) {
    TMToast('Vielen Dank für deine Anmeldung! Du erhältst ab sofort unsere Newsletter per E-Mail.', {
      duration: 12000
    });
    /* Angemeldet: Auto-Popup dauerhaft aus */
    try { localStorage.setItem('tm_nl_subscribed', '1'); } catch (err) {}
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }
});
/* ===== Newsletter auto-open on home + product ===== */
document.addEventListener('DOMContentLoaded', () => {
  const KEY_SHOWN = 'tm_nl_shown_v2';        // max. 1x pro Session
  const KEY_DISMISS = 'tm_nl_dismissed_at';  // 7 Tage Pause nach Wegklicken
  const KEY_DONE = 'tm_nl_subscribed';       // dauerhaft aus nach Anmeldung
  const PAUSE_MS = 7 * 24 * 60 * 60 * 1000;

  const DELAY_MS = 25000;   // Trigger 1: nach 25 Sekunden
  const SCROLL_PCT = 0.45;  // Trigger 2: ab 45 % Scrolltiefe
  const OPEN_DELAY = 300;   // kleine Pause vor dem Einblenden

  const isHome = () => {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/';
  };
  const isProduct = () => {
    return !!(document.querySelector('form[action*="/cart/add"]') && document.querySelector('[name="id"]'));
  };

  const blocked = () => {
    if (window.Shopify && Shopify.designMode) return true; // nicht im Theme-Editor
    try {
      if (localStorage.getItem(KEY_DONE)) return true;
      if (sessionStorage.getItem(KEY_SHOWN)) return true;
      const t = Number(localStorage.getItem(KEY_DISMISS) || 0);
      if (t && Date.now() - t < PAUSE_MS) return true;
    } catch (err) {}
    return false;
  };

  if (!(isHome() || isProduct())) return;
  if (blocked()) return;

  let fired = false;
  let timer = null;

  const openPopup = () => {
    if (fired) return;
    fired = true;
    cleanup();
    if (blocked()) return; // z. B. inzwischen manuell geoeffnet und weggeklickt
    try { sessionStorage.setItem(KEY_SHOWN, '1'); } catch (err) {}
    const modal = document.getElementById('tm-newsletter');
    if (!modal || modal.classList.contains('is-open')) return;
    window.setTimeout(() => {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }, OPEN_DELAY);
  };

  /* Trigger 1: Zeit */
  timer = window.setTimeout(openPopup, DELAY_MS);

  /* Trigger 2: Scrolltiefe */
  const onScroll = () => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= SCROLL_PCT) openPopup();
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Trigger 3: Exit Intent (nur Desktop — Maus verlaesst Fenster oben) */
  const onExit = (e) => {
    if (!e.relatedTarget && e.clientY <= 0) openPopup();
  };
  document.addEventListener('mouseout', onExit);

  function cleanup() {
    window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
  }
});